import React from "react";
import MobileAccesories from "components/MobileAccesories";
import "./Category/category.css";
export default function FavoritePage() {
  return (
    <div>
      <MobileAccesories favorites={true} />
    </div>
  );
}
